module.exports = __webpack_public_path__ + "img/drawGift6.86507a4f.png";